<template>
  <div class="elite-tabs-wrapper-content">
    <h3>{{ " ********* " + nuveiCard?.last4 }}</h3>
    <div class="col-12">
      <dl class="row" v-if="nuveiCard.expiry_month && nuveiCard.expiry_year">
        <dt class="col-sm-4">{{ $t("NUVEI_CARDS.EXPIRATION") }}</dt>
        <dd class="col-sm-8 text-capitalize">
          {{ nuveiCard.expiry_month }}/{{ nuveiCard.expiry_year }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("NUVEI_CARDS.IS_DEFAULT") }}</dt>
        <dd class="col-sm-8">
          {{ nuveiCard.is_default ? $t("COMMON.YES") : $t("COMMON.NO") }}
        </dd>
      </dl>

      <dl class="row" v-if="nuveiCard.customer">
        <dt class="col-sm-4">{{ $t("NUVEI_CARDS.HOLDER") }}</dt>
        <dd class="col-sm-8 text-uppercase">
          {{ nuveiCard.customer.firstname }} {{ nuveiCard.customer.lastname }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
        <dd class="col-sm-8">
          {{ nuveiCard.created_at | moment("LLLL") }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
        <dd class="col-sm-8">
          {{ nuveiCard.updated_at | moment("LLLL") }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: "nuvei-card-view-global",

  props: ["nuveiCard"],

  data() {
    return {};
  },

  methods: {
    nuveiCardUpdated() {
      this.$emit("nuveiCardUpdated", true);
    },
  },

  mounted() {},

  watch: {
    nuveiCard(nuveiCard) {},
  },
};
</script>
